import { mapToList } from "./utils";

export const EnumWithholdChannel = {
  // 无代扣
  NONE: 0,
  // 租赁代扣
  ALIPAY_RENT: 1,
};

export const WithholdChannelToTextMap = new Map([
  [EnumWithholdChannel.NONE, "无代扣"],
  [EnumWithholdChannel.ALIPAY_RENT, "租赁代扣"],
]);

export const WithholdChannelToTypeMap = new Map([
  [EnumWithholdChannel.NONE, ""],
  [EnumWithholdChannel.ALIPAY_RENT, "success"],
]);

export const WithholdChannelList = mapToList(WithholdChannelToTextMap);

// 获取代扣渠道显示文本
export function getWithholdChannelText(withholdChannel) {
  return WithholdChannelToTextMap.get(withholdChannel) || "无代扣";
}

// 获取代扣渠道标签颜色
export function getWithholdChannelType(withholdChannel) {
  return WithholdChannelToTypeMap.get(withholdChannel) || "";
}

// 判断是否显示代扣渠道标签（无代扣时不显示）
export function shouldShowWithholdChannel(withholdChannel) {
  return withholdChannel && withholdChannel !== EnumWithholdChannel.NONE;
}
